import IdeyaTypography from '../../common/antd/ideya-typography'
import { useIsMobile } from '../../common/hooks/use-is-mobile.ts'

export const Rules = () => {
  const isMobile = useIsMobile(768)

  return (
    <div
      style={{
        maxWidth: 900,
        margin: '0 auto',
        padding: isMobile ? '12px 8px' : '32px 20px',
        borderRadius: isMobile ? 8 : undefined,
        boxShadow: isMobile ? '0 2px 8px rgba(0,0,0,0.06)' : undefined,
        fontSize: isMobile ? 14 : undefined,
        display: 'grid',
        gap: isMobile ? 4 : 8,
      }}
    >
      <IdeyaTypography.Title
        level={3}
        style={isMobile ? { fontSize: 20, textAlign: 'center' } : undefined}
      >
        Program Guidelines
      </IdeyaTypography.Title>
      <IdeyaTypography.Title
        level={4}
        style={isMobile ? { fontSize: 16 } : undefined}
      >
        Program Rule considerations:
      </IdeyaTypography.Title>
      <IdeyaTypography.Text>
        Please note: Program Trading Rule criteria may differ per geographic
        region, using different trading universes, liquidity and performance
        measurements.
      </IdeyaTypography.Text>

      <IdeyaTypography.Title
        level={4}
        style={isMobile ? { fontSize: 16, marginTop: 16 } : { marginTop: 16 }}
      >
        Systems you may contribute via:
      </IdeyaTypography.Title>
      <ul style={{ paddingLeft: isMobile ? 18 : 24, listStyleType: 'disc' }}>
        <li>
          <span>
            <IdeyaTypography.Text>IDEYA website</IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Broker's internal systems
            </IdeyaTypography.Text>
          </span>
        </li>
      </ul>
      {isMobile ? (
        <>
          <IdeyaTypography.Title
            level={4}
            style={{ fontSize: 16, marginTop: 16 }}
          >
            Tradeable Universe/
          </IdeyaTypography.Title>
          <IdeyaTypography.Title
            level={4}
            style={{ fontSize: 16, marginTop: 16 }}
          >
            Types of Ideas Accepted:
          </IdeyaTypography.Title>
        </>
      ) : (
        <IdeyaTypography.Title
          level={4}
          style={isMobile ? { fontSize: 16, marginTop: 16 } : { marginTop: 16 }}
        >
          Tradeable Universe / Types of Ideas Accepted:
        </IdeyaTypography.Title>
      )}
      <ul style={{ paddingLeft: isMobile ? 18 : 24, listStyleType: 'disc' }}>
        <li>
          <span>
            <IdeyaTypography.Text>
              Both long and short ideas of any time horizon
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Only single stock ideas will be accepted
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Stocks in Polymer's restricted list will not be accepted
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Stock market cap should be greater than $300M
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Stock should have a 20-day ADV greater than $3M
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Can only short stocks in the list of securities eligible for short
              selling
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For Japan contributors, only Japan ideas will be accepted
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For Greater China contributors, Hong Kong, China A-shares, China
              ADRs and Taiwan ideas will be accepted. Non-Greater China Asia
              developed markets (Japan, Korea, Australia, Singapore) ideas are
              capped at 20% GMV
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For India contributors, only stocks that have single stock futures
              (SSF) will be accepted as ideas; no trades in futures in the F&O
              ban list will be allowed.
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For Korea contributors, only KRX ideas will be accepted (eg No
              Coupang)
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For Australia, only stocks listed under the Australia Securities
              Exchange (ASX) are eligible for trading.
            </IdeyaTypography.Text>
          </span>
        </li>
      </ul>

      <IdeyaTypography.Title
        level={4}
        style={
          isMobile ? { fontSize: 16, marginTop: 16 } : { marginTop: '16px' }
        }
      >
        Rules of Engagement
      </IdeyaTypography.Title>
      <ul style={{ paddingLeft: isMobile ? 18 : 24, listStyleType: 'disc' }}>
        <li>
          <span>
            <IdeyaTypography.Text>
              Portfolio size cap: $100M for Japan; $50M for Greater China; $50M
              for India; $50M for Korea; $50M for Australia;
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Minimum deployment: 50% (after 2-month ramp-up period)
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Minimum new ideas: 10 (soft monthly target)
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>Idea Size: $600K to $5M</IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>Size categories:</IdeyaTypography.Text>
          </span>
          <ul
            style={{
              paddingLeft: isMobile ? 12 : 16,
              listStyleType: 'circle',
              marginTop: 8,
              marginBottom: 8,
            }}
          >
            <li>
              <span>
                <IdeyaTypography.Text>Small - 1M</IdeyaTypography.Text>
              </span>
            </li>
            <li>
              <span>
                <IdeyaTypography.Text>Medium - 3M</IdeyaTypography.Text>
              </span>
            </li>
            <li>
              <span>
                <IdeyaTypography.Text>Large - 5M</IdeyaTypography.Text>
              </span>
            </li>
          </ul>
        </li>

        <li>
          <span>
            <IdeyaTypography.Text>
              Size will also be capped at 20% of 20-day ADV
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For Japan contributors, the Net position (defined as, Long GMV –
              Short GMV, here we use the spot GMV instead of moving avg GMV)
              should be within ±15% of the total GMV (defined as, Long GMV +
              Short GMV)
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For Greater China contributors, we split into 2 categories, Low
              Net and Long Bias
              <br />
              <b>Low Net:</b> the Net position (defined as, Long GMV – Short
              GMV) be within ±15% of the total GMV (defined as, Long GMV + Short
              GMV)
              <br />
              <b>Long Bias:</b> the Net position should be no less than 70% of
              the GMV
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>For India</IdeyaTypography.Text>
            <ul
              style={{
                paddingLeft: isMobile ? 12 : 16,
                listStyleType: 'circle',
                marginTop: 8,
                marginBottom: 8,
              }}
            >
              <li>
                <span>
                  <IdeyaTypography.Text>
                    The Net position (defined as, Long GMV – Short GMV) be
                    within ±15% of the total GMV (defined as, Long GMV + Short
                    GMV)
                  </IdeyaTypography.Text>
                </span>
              </li>
              <li>
                <span>
                  <IdeyaTypography.Text>
                    Impact cost: All positions will incur currency hedging and
                    finance costs for the margin required. Each trade will also
                    incur brokerage costs.
                  </IdeyaTypography.Text>
                </span>
              </li>
              <li>
                <span>
                  <IdeyaTypography.Text>
                    All positions held beyond the monthly futures expiry will
                    incur roll costs
                  </IdeyaTypography.Text>
                </span>
              </li>
            </ul>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>For Korea</IdeyaTypography.Text>
            <ul
              style={{
                paddingLeft: isMobile ? 12 : 16,
                listStyleType: 'circle',
                marginTop: 8,
                marginBottom: 8,
              }}
            >
              <li>
                <span>
                  <IdeyaTypography.Text>
                    The Net position (defined as, Long GMV – Short GMV) be
                    within ±25% of the total GMV (defined as, Long GMV + Short
                    GMV)
                  </IdeyaTypography.Text>
                </span>
              </li>
              <li>
                <span>
                  <IdeyaTypography.Text>
                    Impact cost: All positions will incur a currency hedging
                    cost for the margin required
                  </IdeyaTypography.Text>
                </span>
              </li>
              <li>
                <span>
                  <IdeyaTypography.Text>
                    TAX (only applied when selling the stock) of 0.2% will be
                    blended into P&L
                  </IdeyaTypography.Text>
                </span>
              </li>
            </ul>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>For Australia</IdeyaTypography.Text>
            <ul
              style={{
                paddingLeft: isMobile ? 12 : 16,
                listStyleType: 'circle',
                marginTop: 8,
                marginBottom: 8,
              }}
            >
              <li>
                <span>
                  <IdeyaTypography.Text>
                    The Net position (defined as, Long GMV – Short GMV) be
                    within ±15% of the total GMV (defined as Long GMV + Short
                    GMV)
                  </IdeyaTypography.Text>
                </span>
              </li>
            </ul>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Trade Reason: is required
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>Horizon: is required</IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>Conviction: is required</IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>Target: is required</IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>Stop: is required</IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Transaction cost (commission, borrow cost, slippage, etc.): Yes
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>Auto close rules: No</IdeyaTypography.Text>
          </span>
        </li>
      </ul>

      <IdeyaTypography.Title
        level={4}
        style={
          isMobile ? { fontSize: 16, marginTop: 16 } : { marginTop: '16px' }
        }
      >
        Pricing and Market Data considerations
      </IdeyaTypography.Title>
      <ul style={{ paddingLeft: isMobile ? 18 : 24, listStyleType: 'disc' }}>
        <li>
          <span>
            <IdeyaTypography.Text>
              Two pricing strategies are available to contributors to select
              from:
            </IdeyaTypography.Text>
          </span>
        </li>
        <ul
          style={{
            paddingLeft: isMobile ? 12 : 16,
            listStyleType: 'circle',
            marginTop: 8,
            marginBottom: 8,
          }}
        >
          <li>
            <span>
              <IdeyaTypography.Text>Next One-hour VWAP:</IdeyaTypography.Text>
            </span>
            <ul
              style={{
                paddingLeft: isMobile ? 12 : 16,
                listStyleType: 'circle',
                marginTop: 8,
                marginBottom: 8,
              }}
            >
              <li>
                <span>
                  &quot;Auto Fill Residual Order&quot; not selected: Trades will
                  be executed based on the VWAP of the next 60 minutes from the
                  time of entry.
                </span>
              </li>
              <li>
                <span>
                  &quot;Auto Fill Residual Order&quot; is selected: If the trade
                  cannot be completed in the next 60 mins due to our internal
                  liquidity parameters, the residual volume will be executed
                  every subsequent hour until filled. If the trade is not filled
                  by EOD, the residual will be carried forward to the next day
                  and executed in hourly intervals.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <span>
              <IdeyaTypography.Text>VWAP until EOD:</IdeyaTypography.Text>
            </span>
            <ul
              style={{
                paddingLeft: isMobile ? 12 : 16,
                listStyleType: 'circle',
                marginTop: 8,
                marginBottom: 8,
              }}
            >
              <li>
                <span>
                  Trades will be priced based on VWAP until EOD from the time
                  the order is received. If there is a residual at the end of
                  day, it will be filled the next day based on VWAP until EOD.
                </span>
              </li>
            </ul>
          </li>
        </ul>
        <li>
          <span>
            <IdeyaTypography.Text>Residual orders:</IdeyaTypography.Text>
          </span>
          <ul
            style={{
              paddingLeft: isMobile ? 12 : 16,
              listStyleType: 'circle',
              marginTop: 8,
              marginBottom: 8,
            }}
          >
            <li>
              <span>
                Contributors will have the option to toggle auto fill of
                residual orders. When selected, any residual order at the EOD
                will be filled on the next day based on full day VWAP based on
                our internal liquidity parameters.
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Trades entered within the last 15 minutes of the trading session
              will receive the VWAP according to the selected pricing strategy
              for the next trading day
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Pre-market trades will receive the VWAP according to the selected
              pricing strategy after market opens.
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Post-market trades will receive the VWAP according to the selected
              pricing strategy for the next trading day
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For India: Pricing will be based on SSF data from the National
              Stock Exchange (NSE)
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For Korea: Pricing will be based on KRX data (no NXT)
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              For Australia: Pricing will be based on ASX data.
            </IdeyaTypography.Text>
          </span>
        </li>
      </ul>

      <IdeyaTypography.Title
        level={4}
        style={
          isMobile ? { fontSize: 16, marginTop: 16 } : { marginTop: '16px' }
        }
      >
        Performance Measurement
      </IdeyaTypography.Title>
      <ul style={{ paddingLeft: isMobile ? 18 : 24, listStyleType: 'disc' }}>
        <li>
          <span>
            <IdeyaTypography.Text>
              Japan Contributors will be measured on a dollar-weighted, Absolute
              return against $100M portfolio size
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Greater China Contributors will be measured on a dollar-weighted,
              Absolute return against $50M portfolio size
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              India Contributors will be measured on a dollar-weighted, Absolute
              return against $50M portfolio size
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Korea Contributors will be measured on a dollar-weighted, Absolute
              return against $50M portfolio size
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Australia Contributors will be measured on a dollar-weighted,
              Absolute return against $50M portfolio size
            </IdeyaTypography.Text>
          </span>
        </li>
      </ul>

      <IdeyaTypography.Title
        level={4}
        style={
          isMobile ? { fontSize: 16, marginTop: 16 } : { marginTop: '16px' }
        }
      >
        Compensation
      </IdeyaTypography.Title>
      <ul style={{ paddingLeft: isMobile ? 18 : 24, listStyleType: 'disc' }}>
        <li>
          <span>
            <IdeyaTypography.Text>
              Performance ranking for compensation will occur by calendar
              quarter
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Compensation will be made on an individual basis and aggregated
              firm basis (post netting) all to be paid at the firm level
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Monitoring: Performance ranking will be updated daily in the
              portal
            </IdeyaTypography.Text>
          </span>
        </li>
        <li>
          <span>
            <IdeyaTypography.Text>
              Firm has sole discretion to determine whether any compensation is
              payable and, if so, the amount of compensation to be paid.
            </IdeyaTypography.Text>
          </span>
        </li>
      </ul>

      <IdeyaTypography.Title
        level={4}
        style={
          isMobile ? { fontSize: 16, marginTop: 16 } : { marginTop: '16px' }
        }
      >
        Contributor Exclusion
      </IdeyaTypography.Title>
      <IdeyaTypography.Text>
        Firm reserves the right to terminate any individual contributor or
        participating firm at any time. This may be for any reason at Firm's
        discretion including performance issues.
      </IdeyaTypography.Text>

      <br />
      <br />

      <IdeyaTypography.Text>
        For technical support please contact{' '}
        <a href={'mailto:support@polymerideya.com'}>support@polymerideya.com</a>
      </IdeyaTypography.Text>
    </div>
  )
}
